import { useState } from "react";
import CustomTabs from "../../../common/Tabs";

const VesselFuelExpenseTable = ({
    isReadOnly = false,
    fuelExpenseData = {},
    setfuelExpenseData = () => { },
}) => {
    const [activeTab, setActiveTab] = useState(0);

    const handleChange = (field, value) => {
        setfuelExpenseData((prev) => ({
            ...prev,
            fuelExpenseData: {
                ...prev.fuelExpenseData,
                [field]: value,
            },
        }));
    };

    const tabs = [
        { key: 0, label: "HSFO (Main)" },
        { key: 1, label: "LSFO (ECA)" },
        { key: 2, label: "MGO (Light Fuel)" },
    ];

    const methodKeys = ["fuelMethodHsfo", "fuelMethodLsfo", "fuelMethodMgo"];

    const rowConfig = [
        {
            label: "Reserve External",
            qtyKeys: [
                "reserveExternalQtyHsfo",
                "reserveExternalQtyLsfo",
                "reserveExternalQtyMgo",
            ],
            costKeys: null,
            priceKeys: null,
        },
        {
            label: "Delivery-In (Commence)",
            qtyKeys: [
                "fuelQtyDeliveryInHsfo",
                "fuelQtyDeliveryInLsfo",
                "fuelQtyDeliveryInMgo",
            ],
            costKeys: [
                "valueFuelDeliveryInHsfo",
                "valueFuelDeliveryInLsfo",
                "valueFuelDeliveryInMgo",
            ],
            priceKeys: [null, null, "payableVendorMgo"],
            className: "bg-blue-50",
        },
        {
            label: "Delivery-Out",
            qtyKeys: [
                "fuelQtyDeliveryOutHsfo",
                "fuelQtyDeliveryOutLsfo",
                "fuelQtyDeliveryOutMgo",
            ],
            costKeys: [
                "valueFuelDeliveryOutHsfo",
                "valueFuelDeliveryOutLsfo",
                "valueFuelDeliveryOutMgo",
            ],
            priceKeys: [
                "receivableCustomerHsfo",
                null,
                "receivableCustomerMgo",
            ],
        },
        {
            label: "Redelivery-In",
            qtyKeys: [
                "fuelQtyRedeliveryInHsfo",
                "fuelQtyRedeliveryInLsfo",
                "fuelQtyRedeliveryInMgo",
            ],
            costKeys: [
                "valueFuelRedeliveryInHsfo",
                "valueFuelRedeliveryInLsfo",
                "valueFuelRedeliveryInMgo",
            ],
            priceKeys: [
                "payableCustomerHsfo",
                null,
                "payableCustomerMgo",
            ],
        },
        {
            label: "Actual On Redelivery-Out",
            qtyKeys: [
                "fuelQtyActualRedeliveryOutHsfo",
                "fuelQtyActualRedeliveryOutLsfo",
                "fuelQtyActualRedeliveryOutMgo",
            ],
            costKeys: [
                "valueFuelRedeliveryOutHsfo",
                "valueFuelRedeliveryOutLsfo",
                "valueFuelRedeliveryOutMgo",
            ],
            priceKeys: [
                null,
                null,
                "receivableVendorMgo",
            ],
            className: "bg-blue-50",
        },
        {
            label: "Effective Vessel-Out Purchase",
            qtyKeys: [
                "vesselOutFuelPurchaseHsfo",
                "vesselOutFuelPurchaseLsfo",
                "vesselOutFuelPurchaseMgo",
            ],
            costKeys: ["purchaseCostHsfo", "purchaseCostLsfo", "purchaseCostMgo"],
            priceKeys: [
                null,
                null,
                "vesselOutFuelPriceMgo",
            ],
        },
        {
            label: "Reserve Internal Total",
            qtyKeys: [
                "reserveInternalQtyHsfo",
                "reserveInternalQtyLsfo",
                "reserveInternalQtyMgo",
            ],
            costKeys: [
                "reserveInternalCostHsfo",
                "reserveInternalCostLsfo",
                "reserveInternalCostMgo",
            ],
            priceKeys: [
                "reserveInternalPriceHsfo",
                null,
                null
            ],
        },
        {
            label: "Trip Supply Internal Total",
            qtyKeys: [
                "supplyInternalQtyHsfo",
                "supplyInternalQtyLsfo",
                "supplyInternalQtyMgo",
            ],
            costKeys: [
                "supplyInternalCostHsfo",
                "supplyInternalCostLsfo",
                "supplyInternalCostMgo",
            ],
            priceKeys: [
                "supplyInternalPriceHsfo",
                "supplyInternalPriceLsfo",
                "supplyInternalPriceMgo",
            ],
        },
        {
            label: "Internal Total",
            qtyKeys: [
                "totalInternalQtyHsfo",
                "totalInternalQtyLsfo",
                "totalInternalQtyMgo",
            ],
            costKeys: [
                "totalInternalCostHsfo",
                "totalInternalCostLsfo",
                "totalInternalCostMgo",
            ],
            priceKeys: [
                "totalInternalPriceHsfo",
                null,
                null,
            ],
            className: "font-bold bg-gray-50",
        },
        {
            isMethodRow: true,
            label: "Fuel Calculation Method",
        },
        { isSeparator: true },
        {
            label: "Shortage",
            qtyKeys: ["shortageQtyHsfo", "shortageQtyLsfo", "shortageQtyMgo"],
            costKeys: ["shortageCostHsfo", "shortageCostLsfo", "shortageCostMgo"],
            priceKeys: ["shortagePriceHsfo", "shortagePriceLsfo", "shortagePriceMgo"],
            priceIsInput: true,
            className: "text-red-600 font-medium",
        },
        {
            label: "Voyage Consumption",
            qtyKeys: [
                "voyageConsumptionQtyHsfo",
                "voyageConsumptionQtyLsfo",
                "voyageConsumptionQtyMgo",
            ],
            costKeys: [
                "voyageFuelCostHsfo",
                "voyageFuelCostLsfo",
                "voyageFuelCostMgo",
            ],
            priceKeys: null
        },
        {
            label: "Balance Internal",
            qtyKeys: [
                "balanceQtyInternalHsfo",
                "balanceQtyInternalLsfo",
                "balanceQtyInternalMgo",
            ],
            costKeys: [
                "costForBalanceQtyHsfo",
                "costForBalanceQtyLsfo",
                "costForBalanceQtyMgo",
            ],
            priceKeys: ["pricePerMtHsfo", "pricePerMtLsfo", "pricePerMtMgo"],
        },
        { isSectionHeader: true, label: "Fuel Hand-Over" },
        {
            label: "Fuel Hand-Over",
            qtyKeys: [
                "fuelHandOverQtyHsfo",
                "fuelHandOverQtyLsfo",
                "fuelHandOverQtyMgo",
            ],
            costKeys: [
                "revenueForHandOverHsfo",
                "revenueForHandOverLsfo",
                "revenueForHandOverMgo",
            ],
            priceKeys: [
                "fuelHandOverPriceHsfo",
                "fuelHandOverPriceLsfo",
                "fuelHandOverPriceMgo",
            ],
            priceIsInput: true,
            className: "font-bold",
        },
        {
            label: "Fuel Hand-Over Profit",
            qtyKeys: null,
            costKeys: [
                "fuelHandOverProfitHsfo",
                "fuelHandOverProfitLsfo",
                "fuelHandOverProfitMgo",
            ],
            priceKeys: null,
            className: "font-bold bg-gray-50",
        },
        {
            label: "Total Fuel Hand-Over Profit",
            isGrandTotal: true,
            totalKey: "totalFuelHandOverProfit",
            className: "font-bold text-black bg-sky-100",
        },
        { isSectionHeader: true, label: "Fuel Settlement" },
        {
            label: "Voyage Fuel Expenditure",
            qtyKeys: null,
            costKeys: [
                "voyageFuelExpenditureHsfo",
                "voyageFuelExpenditureLsfo",
                "voyageFuelExpenditureMgo",
            ],
            priceKeys: null,
            className: "bg-gray-50 font-semibold",
        },
        {
            label: "Fuel Settlement Profit",
            qtyKeys: null,
            costKeys: [
                "fuelSettlementProfitHsfo",
                "fuelSettlementProfitLsfo",
                "fuelSettlementProfitMgo",
            ],
            priceKeys: null,
            className: "bg-green-50 font-bold text-green-900",
        },
    ];

    const t = activeTab;

    const renderDataCell = (keys, row, isLast) => {
        const borderClass = "border-r border-b border-[#cbd5e1]";
        const key = keys?.[t];

        if ((!key || fuelExpenseData?.[key] == null) && !row.priceIsInput) {
            return (
                <td className={`px-2 py-1 text-right text-slate-400 text-[11px] font-medium ${borderClass}`}>
                    —
                </td>
            );
        }
        if (row.priceIsInput && isLast) {
            return (
                <td className={`p-0 ${borderClass} bg-[#ffffd6] h-[20px] align-middle`}>
                    <input
                        type="number"
                        value={fuelExpenseData[key] ?? ""}
                        onChange={(e) => handleChange(key, e.target.value)}
                        disabled={isReadOnly}
                        className="w-full h-full px-1.5 py-0 border-none outline-none font-medium text-right focus:bg-white focus:ring-1 focus:ring-inset focus:ring-amber-500 bg-[#ffffd6] text-slate-900 text-[11px] capitalize"
                        placeholder="0.00"
                    />
                </td>
            );
        }
        return (
            <td
                className={`px-2 py-0.5 text-right text-slate-800 text-[11px] font-medium bg-[#f0f4f9] ${borderClass} ${row.className || ""}`}
            >
                {fuelExpenseData[key] ?? "0.00"}
            </td>
        );
    };

    return (
        <div className="w-full max-w-7xl mx-auto p-2 text-[11px] font-medium">
            {/* Tab Switcher */}
            <div className="w-fit mb-3">
                <CustomTabs tabs={tabs} active={activeTab} setActive={setActiveTab} />
            </div>

            {/* Main Table */}
            <div className="bg-white border border-[#cbd5e1] rounded-none overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse text-[11px] font-medium table-fixed">
                        <thead>
                            <tr className="bg-[#e2e8f0] text-[#1e293b] h-[20px]">
                                <th className="px-2.5 py-0.5 text-left text-[#1e293b] font-medium border-r border-b border-[#cbd5e1] w-1/4 capitalize">
                                    Description
                                </th>
                                <th className="px-2.5 py-0.5 text-center text-[#1e293b] font-medium border-r border-b border-[#cbd5e1] w-1/4 capitalize">
                                    Quantity
                                </th>
                                <th className="px-2.5 py-0.5 text-center text-[#1e293b] font-medium border-r border-b border-[#cbd5e1] w-1/4 capitalize">
                                    Cost (Value)
                                </th>
                                <th className="px-2.5 py-0.5 text-center text-[#1e293b] font-medium border-r border-b border-[#cbd5e1] w-1/4 capitalize">
                                    Per MT Price
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white">
                            {rowConfig.map((row, idx) => {
                                if (row.isSeparator) {
                                    return (
                                        <tr key={idx} className="h-1 bg-slate-100">
                                            <td colSpan="4" className="border-b border-[#cbd5e1]" />
                                        </tr>
                                    );
                                }

                                if (row.isSectionHeader) {
                                    return (
                                        <tr
                                            key={idx}
                                            className="bg-[#e2e8f0] text-[#1e293b] h-[20px]"
                                        >
                                            <td
                                                colSpan="4"
                                                className="px-2.5 py-0.5 font-medium text-[#1e293b] text-[11px] border-r border-b border-[#cbd5e1] capitalize"
                                            >
                                                {row.label}
                                            </td>
                                        </tr>
                                    );
                                }

                                if (row.isMethodRow) {
                                    const methodKey = methodKeys[t];
                                    return (
                                        <tr
                                            key={idx}
                                            className="bg-white border-b border-[#cbd5e1] h-[20px]"
                                        >
                                            <td className="px-2.5 py-0.5 font-medium text-slate-700 border-r border-b border-[#cbd5e1] truncate text-[11px] capitalize">
                                                {row.label}
                                            </td>
                                            <td
                                                className="p-0 border-r border-b border-[#cbd5e1] bg-[#ffffd6] h-[20px] align-middle"
                                                colSpan="3"
                                            >
                                                <select
                                                    value={fuelExpenseData[methodKey] ?? "Average"}
                                                    onChange={(e) =>
                                                        handleChange(methodKey, e.target.value)
                                                    }
                                                    disabled={isReadOnly}
                                                    className="w-full h-full px-1.5 py-0 border-none outline-none font-medium focus:bg-white focus:ring-1 focus:ring-inset focus:ring-amber-500 bg-[#ffffd6] text-slate-900 text-[11px] cursor-pointer capitalize"
                                                >
                                                    <option>Average</option>
                                                    <option>LIFO</option>
                                                    <option>FIFO</option>
                                                </select>
                                            </td>
                                        </tr>
                                    );
                                }

                                if (row.isGrandTotal) {
                                    return (
                                        <tr
                                            key={idx}
                                            className="bg-[#f0f4f9] border-b border-[#cbd5e1]"
                                        >
                                            <td className="px-3 py-1 font-medium text-slate-800 border-r border-b border-[#cbd5e1] truncate">
                                                {row.label}
                                            </td>
                                            <td
                                                colSpan="3"
                                                className="px-3 py-1 text-right font-medium text-[11px] text-slate-900 border-b border-[#cbd5e1]"
                                            >
                                                {fuelExpenseData[row.totalKey] ?? "0.00"}
                                            </td>
                                        </tr>
                                    );
                                }

                                return (
                                    <tr
                                        key={idx}
                                        className="hover:bg-slate-50/50 transition-colors border-b border-[#cbd5e1]"
                                    >
                                        <td className="px-3 py-1 text-slate-700 border-r border-b border-[#cbd5e1] truncate">
                                            {row.label}
                                        </td>
                                        {renderDataCell(row.qtyKeys, row, false)}
                                        {renderDataCell(row.costKeys, row, false)}
                                        {renderDataCell(row.priceKeys, row, true)}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default VesselFuelExpenseTable;
